import React, { createContext, useContext, useState, useEffect } from 'react';
import it from '../locales/it.json';
import en from '../locales/en.json';
import pl from '../locales/pl.json';
import de from '../locales/de.json';

const translations = { it, en, pl, de };

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('automat_language');
    return saved || 'it';
  });

  useEffect(() => {
    localStorage.setItem('automat_language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, translations }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
